import ApiService from "../common/api.service";
import StorageService from "../common/storage.service";
import Vue from "vue";
import { redirectUnauthorizedUser } from "../common/auth-redirect.util";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import {
  REDIRECTED_USER,
  CHECK_AUTH,
  LOGIN_USER_CANVAS,
  REGISTER_EXISTING,
  LOG_USER_OUT,
  NEW_CANVAS_USER,
  EMAIL_VALIDATION
} from "./actions.type";
import {
  SET_AUTH,
  PURGE_AUTH,
  SET_ERROR,
  MUTATE_ITEMS
} from "./mutations.type";
import storageService from "../common/storage.service";

const getResponsePayload = responseData => {
  if (!responseData) {
    return responseData;
  }

  if (
    responseData.data &&
    !responseData.user &&
    !responseData.courses &&
    !responseData.destination_url
  ) {
    return responseData.data;
  }

  return responseData;
};

const getAuthPayload = responseData => {
  const payload = getResponsePayload(responseData);

  if (!payload || (!payload.user && !payload.courses)) {
    return payload;
  }

  return {
    ...payload,
    status: payload.status || responseData.status || responseData.code
  };
};

const state = {
  errors: null,
  user: {},
  isAuthenticated: false,
  courses: []
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  items(state) {
    return state.items;
  }
};

// TODO: if user is new_user then redirect user with oauth flow.
const actions = {
  [REDIRECTED_USER](context, credentials) {
    return new Promise(resolve => {
      ApiService.query(`lms/user/rfiValidation/${credentials}`)
        .then(({ data }) => {
          const payload = getResponsePayload(data);

          if (payload.user.status === "lead") {
            context.commit(SET_AUTH, payload.user);
            resolve(payload);
          } else {
            resolve(payload);
          }
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
          if (response.status === 401) {
            redirectUnauthorizedUser(response);
          } else if (response.status === 400) {
            Vue.swal({
              type: "error",
              title: "Oops...",
              text: response.data.message
            });
          }
          resolve(response);
        });
    });
  },
  [NEW_CANVAS_USER](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post(`lms/user?nocache=${new Date().getTime()}`, {
        course_id: credentials.course_id,
        email_address: credentials.email_address,
        first_name: credentials.first_name,
        last_name: credentials.last_name,
        password: credentials.password,
        origin_uri: window.location.hostname
      })
        .then(({ data }) => {
          const payload = getResponsePayload(data);

          context.commit(SET_AUTH, payload.user);
          resolve(payload);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },

  [CHECK_AUTH](context, clickLocale) {
    console.log(storageService.getData())
    return new Promise(resolve => {
      ApiService.query(`lms/user?clickLocale=${clickLocale}&nocache=${new Date().getTime()}`)
        .then(({ data }) => {
          const payload = getAuthPayload(data);

          context.commit(SET_AUTH, payload);
          resolve(payload);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
          if (response.status === 401) {
            redirectUnauthorizedUser(response);
          } else if (response.status === 400) {
            Vue.swal({
              type: "error",
              title: "Oops...",
              text: response.data.message
            });
          }
          resolve(response);
        });
    });
  },
  [LOGIN_USER_CANVAS](context, stateANDdata) {
    return new Promise(resolve => {
      ApiService.post(`lms/user/auth/login?nocache=${new Date().getTime()}`, {
        code: stateANDdata.data.code
      })
        .then(({ data }) => {
          const payload = getAuthPayload(data);

          context.commit(SET_AUTH, payload);
          resolve(payload);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
          if (response.status === 401) {
            redirectUnauthorizedUser(response);
          } else if (response.status === 400) {
            Vue.swal({
              type: "error",
              title: "Oops...",
              text: response.data.message
            });
          }
          resolve(response);
        });
    });
  },
  [LOG_USER_OUT](context, email_address) {
    return new Promise(resolve => {
      ApiService.post(
        `/lms/user/auth/logout?email_address=${encodeURIComponent(
          email_address
        )}`
      )
        .then(({ data }) => {
          resolve(getResponsePayload(data));
          context.commit(PURGE_AUTH);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
          if (response.status === 401) {
            redirectUnauthorizedUser(response);
          } else if (response.status === 400) {
            Vue.swal({
              type: "error",
              title: "Oops...",
              text: response.data.message
            });
          }
          resolve(response);
        });
    });
  },
  [EMAIL_VALIDATION](context) {
    return new Promise(resolve => {
      ApiService.query(
        `lms/user/emailValidation?email=${encodeURIComponent(
          context.state.user.email_address
        )}`
      )
        .then(({ data }) => {
          const payload = getAuthPayload(data);

          context.commit(SET_AUTH, payload);
          resolve(payload);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
          if (response.status === 401) {
            redirectUnauthorizedUser(response);
          } else if (response.status === 400) {
            Vue.swal({
              type: "error",
              title: "Oops...",
              text: response.data.message
            });
          }
          resolve(response);
        });
    });
  },
  [REGISTER_EXISTING](context, courseId) {
    return new Promise(resolve => {
      ApiService.post(`lms/user/enroll?nocache=${new Date().getTime()}`, {
        course_id: courseId.course_id
      })
        .then(({ data }) => {
          resolve(getResponsePayload(data));
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response);
          if (response.status === 401) {
            redirectUnauthorizedUser(response.data);
          }
          if (response.status === 400) {
            Vue.swal({
              type: "error",
              title: "Oops...",
              text: response.data.message
            });
          }
          resolve(response);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    StorageService.saveData(state);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
  },
  [MUTATE_ITEMS](state, items) {
    Vue.set(items, "id", items.id);
    state.items = items;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
